/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolAgricultureIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-agriculture"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M5.9 20.3Q3.7 20.3 2.17 18.77Q0.65 17.25 0.65 15.05Q0.65 12.85 2.17 11.32Q3.7 9.8 5.9 9.8Q8.1 9.8 9.63 11.32Q11.15 12.85 11.15 15.05Q11.15 17.25 9.63 18.77Q8.1 20.3 5.9 20.3ZM5.9 16.68Q5.22 16.68 4.75 16.2Q4.28 15.72 4.28 15.05Q4.28 14.38 4.75 13.9Q5.22 13.43 5.9 13.43Q6.58 13.43 7.05 13.9Q7.53 14.38 7.53 15.05Q7.53 15.72 7.05 16.2Q6.58 16.68 5.9 16.68ZM19.65 20.35Q18.1 20.35 17.02 19.27Q15.95 18.2 15.95 16.65Q15.95 15.1 17.02 14.03Q18.1 12.95 19.65 12.95Q21.2 12.95 22.27 14.03Q23.35 15.1 23.35 16.65Q23.35 18.2 22.27 19.27Q21.2 20.35 19.65 20.35ZM3.9 8.9Q3.42 8.9 3.09 8.56Q2.75 8.22 2.75 7.75Q2.75 7.28 3.09 6.96Q3.42 6.65 3.9 6.65L6.9 6.65Q7.85 6.65 8.5 7.31Q9.15 7.97 9.1 8.9L9.1 8.9ZM5.9 18.05Q5.9 18.05 6.53 18.05Q7.15 18.05 8.03 17.18Q8.9 16.3 8.9 15.05Q8.9 13.8 8.03 12.93Q7.15 12.05 5.9 12.05Q4.65 12.05 3.77 12.93Q2.9 13.8 2.9 15.05Q2.9 16.3 3.77 17.18Q4.65 18.05 5.9 18.05ZM19.65 18.1Q19.65 18.1 19.95 18.1Q20.25 18.1 20.68 17.68Q21.1 17.25 21.1 16.65Q21.1 16.05 20.68 15.63Q20.25 15.2 19.65 15.2Q19.05 15.2 18.63 15.63Q18.2 16.05 18.2 16.65Q18.2 17.25 18.63 17.68Q19.05 18.1 19.65 18.1ZM12.05 16.2L14.97 16.2Q15.2 14.3 16.6 13.15Q18 12 19.73 12Q20.4 12 21.07 12.2Q21.75 12.4 22.4 12.82L22.4 8Q22.4 7.05 21.75 6.4Q21.1 5.75 20.15 5.75L13.6 5.75L12.55 4.6L13.63 3.52Q13.78 3.38 13.76 3.16Q13.75 2.95 13.6 2.8Q13.45 2.65 13.24 2.66Q13.03 2.67 12.88 2.83L10 5.72Q9.85 5.88 9.86 6.09Q9.88 6.3 10.03 6.45Q10.18 6.6 10.38 6.6Q10.57 6.6 10.72 6.45L11.8 5.35L12.9 6.45L12.9 8.95Q12.9 9.75 12.35 10.3Q11.8 10.85 11 10.85L10.53 10.85Q11.32 11.75 11.72 12.86Q12.13 13.97 12.13 15.18Q12.13 15.45 12.11 15.69Q12.1 15.93 12.05 16.2Z" fill={color} />
    </svg>
  );
}
